var map = {
	"./banner.jpg": "da56",
	"./banner_en.jpg": "0704",
	"./banner_es.jpg": "b7b9",
	"./banner_hk.jpg": "2d6e",
	"./banner_pt.jpg": "d7d0",
	"./banner_tr.jpg": "87288"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1da3";